__turbopack_context__.v({
  "card": "Card-module__-dQiEq__card",
  "cardBase": "Card-module__-dQiEq__cardBase",
  "cardBorder": "Card-module__-dQiEq__cardBorder",
  "cardLg": "Card-module__-dQiEq__cardLg",
  "cardMd": "Card-module__-dQiEq__cardMd",
  "cardXl": "Card-module__-dQiEq__cardXl",
  "card__headerIcon": "Card-module__-dQiEq__card__headerIcon",
});
